import React from "react"
import ExecutorList from "./executor-list"
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
import { notification } from "antd"


notification.config({
  duration: 1,
  rtl: true,
})

const Executors = props => {
  const { t, openNotification } = props
  return <ExecutorList translate={t} openNotification={openNotification} />
}

export default withRouter(withTranslation()(Executors))
